module.exports = __webpack_public_path__ + "img/104.24ed2032.gif";